module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-gray-dark-on-red-dark-ae181e650222ed603037259cfa23cdd2.png";